<template>
  <div class="h-screen w-screen max-w-screen-xl mx-auto">
    <div class="h-12 md:h-24"></div>
    <div class="parent p-2">
      <div
        class="
          div1
          flex
          text-primary
          bg-secondary
          md:block md:bg-secondary md:text-primary
        "
      >
        <h3
          class="
            my-auto
            mx-auto
            text-2xl
            md:text-4xl md:text-right md:mx-8
            lg:mx-16
          "
        >
          {{ titulo }}
        </h3>
      </div>
      <div
        class="
          div2
          flex flex-wrap
          items-start
          justify-start
          overflow-auto
          relative
        "
      >
        <!--div-->
        <!-- card -->
        <div
          class="w-full md:w-1/2 lg:w-1/3 vestido"
          v-for="(card, index) in vestidos"
          :key="index + card.id"
        >
          <article class="p-0 mx-4 my-4 bg-opacity-25 min-w-sm bg-primary">
            <div class="bg-secondary bg-opacity-50 relative">
              <div
                class="bg-primary p-1 rounded-full absolute right-0 m-2 flex "
              >
                <span
                  @click="shareDress(card)"
                  class="material-icons text-base lg:text-lg text-secondary p-1"
                  >share</span
                >
              </div>
              <router-link
                :to="'/' + card.producto + '/' + card.id + '/'"
                class=""
              >
                <!-- <img :src="card.link" class="conte" loading="lazy" /> -->
                <LazyImage :src="card.link" class="conte" />
              </router-link>
              <header
                class="
                  absolute
                  head
                  w-full
                  bottom-0
                  flex
                  items-center
                  justify-between
                  leading-tight
                  p-1
                  md:p-2
                "
              >
                <div class="w-1/2 px-2 my-1">
                  <router-link
                    :to="'/' + card.producto + '/' + card.id + '/'"
                    @click="consulta"
                  >
                    <p
                      class="
                        justify-self-start
                        subpixel-antialiased
                        no-underline
                        text-xs text-secondary
                        md:text-base md:break-words
                        hover:underline
                      "
                      href="#"
                    >
                      {{ card.name }}
                    </p>
                    <!--p class="truncate text-secondary text-xs md:text-sm">
                                            {{card.desc}}
                                        </p-->
                  </router-link>
                </div>
                <div class="flex flex-col">
                  <p
                    class="
                      text-secondary
                      my-auto
                      mx-auto
                      font-black
                      text-sm
                      md:text-md
                    "
                    v-if="card.producto == 'vestido' && card.precio"
                  >
                    Ref: {{ card.precio }}
                  </p>
                </div>
                <div class="flex flex-col justify-self-end py-1">
                  <div class="flex flex-col space-y-1 mb-1">
                    <p
                      class="flex text-secondary ml-auto text-xs md:text-xs"
                      v-if="
                        card.producto == 'salud' || card.producto == 'belleza'
                      "
                    >
                      Stock Cios&emsp;
                      <spam
                        class="flex bg-red mx-auto my-auto w-4 h-4 rounded-full"
                        ><p class="mx-auto my-auto font-bold">
                          {{ card.cantidad }}
                        </p></spam
                      >
                    </p>
                    <p
                      class="flex text-secondary ml-auto text-xs md:text-xs"
                      v-if="
                        (card.producto == 'salud' &&
                          card.cantidad2 == undefined) ||
                          (card.producto == 'belleza' &&
                            card.cantidad2 == undefined)
                      "
                    >
                      Stock Caracas&emsp;
                      <spam
                        class="flex bg-red mx-auto my-auto w-4 h-4 rounded-full"
                      >
                        <p class="mx-auto my-auto font-bold">0</p>
                      </spam>
                    </p>
                    <p
                      class="flex text-secondary ml-auto text-xs md:text-xs"
                      v-if="
                        (card.producto == 'salud' &&
                          card.cantidad2 != undefined) ||
                          (card.producto == 'belleza' &&
                            card.cantidad2 != undefined)
                      "
                    >
                      Stock Caracas&emsp;
                      <spam
                        class="flex bg-red mx-auto my-auto w-4 h-4 rounded-full"
                        ><p class="mx-auto my-auto font-bold">
                          {{ card.cantidad2 }}
                        </p></spam
                      >
                    </p>
                  </div>
                  <a
                    :href="pidelo + '/' + card.producto + '/' + card.id + '/'"
                    class="
                      z-10
                      px-1
                      flex
                      my-auto
                      ml-auto
                      bg-secondary
                      rounded-full
                      text-primary
                      hover:bg-primary
                      hover:text-secondary
                      hover:border
                      hover:border-secondary
                    "
                    @click="contacto"
                  >
                    <p
                      v-if="
                        card.producto == 'salud' || card.producto == 'belleza'
                      "
                      class="my-auto uppercarse text-xs md:block md:text-md"
                    >
                      Comprar
                    </p>
                    <p
                      v-if="
                        card.producto != 'salud' && card.producto != 'belleza'
                      "
                      class="my-auto uppercarse text-xs md:block md:text-md"
                    >
                      contacto
                    </p>
                    <span
                      class="
                        material-icons
                        flex
                        mx-auto
                        my-auto
                        text-xs
                        p-1
                        md:hidden
                      "
                      >shopping_cart</span
                    >

                    <!--span  class="material-icons my-auto text-sm text-xl md:hidden">
                                        <img src="@/assets/media/ws.svg" width="30" height="30">
                                        </span-->
                  </a>
                </div>
                <button class="focus:outline-none hidden">
                  <a
                    :href="pidelo + '/' + card.producto + '/' + card.id + '/'"
                    class="
                      z-20
                      px-2
                      my-auto
                      mx-2
                      tracking-wide
                      bg-primary
                      rounded-full
                      text-secondary
                      flex
                      hover:bg-secondary
                      hover:text-primary
                      hover:border
                      hover:border-secondary
                    "
                    ><span class="material-icons my-auto text-xl md:text-sm p-1"
                      >place</span
                    ></a
                  >
                </button>
              </header>
              <!--/router-link-->
            </div>
            <!--footer class="my-1 p-2 flex items-center justify-end">
                            <a class="px-2 my-auto mx-2 tracking-wide  bg-secondary rounded-full text-primary hover:bg-primary hover:text-secondary hover:border hover:border-secondary">Contacto</a>
                        </footer-->
          </article>
          <!--/div-->
        </div>
        <!-- card -->
        <div v-if="cargando" class="flex w-full md:h-20">
          <p class="mx-auto md:my-auto">Cargando...</p>
        </div>
        <div class="h-24 w-full md:h-20">
          <div
            class="my-4 w-3 h-3 bg-primary rounded-full mx-auto md:my-auto"
          ></div>
        </div>

        <!-- v-if="this.filtros == 'Salud'" -->
        <button
          class="
            arriba
            fixed
            right-0
            bottom-0
            mb-16
            mt-1
            mx-2
            md:m-6
            flex
            block
            p-0
            w-8
            h-8
            bg-primary
            rounded-full
            focus:outline-none
            md:hidden
          "
          @click="isOpen = !isOpen"
        >
          <span class="material-icons text-2xl my-auto mx-auto text-secondary"
            >search</span
          >
        </button>

        <button
          class="
            fixed
            z-0
            right-0
            bottom-0
            m-2
            h-12
            w-12
            md:h-auto md:w-auto md:m-6
            z-30
            flex
            block
            p-0
            bg-wasap-2
            text-secondary
            rounded-full
            active:shadow-lg
            mouse
            shadow
            transition
            ease-in
            delay-1000
            duration-700
            focus:outline-none
          "
        >
          <a href="https://wa.me/584128002579" class="flex my-auto mx-auto">
            <p
              class="
                hidden
                flex
                my-auto
                md:block
                my-auto
                m-2
                text-xs
                font-semibold
              "
            >
              Conversa con nosotros
            </p>
            <img
              class="rounded-full p-1"
              src="@/assets/media/ws-green.svg"
              width="45"
              height="45"
            />
          </a>
        </button>
      </div>
      <!-- Filtros -->
      <div class="div3 hidden md:flex flex-col mx-2 md:mt-2">
        <div
          v-if="
            this.filtros == 'Salud' ||
              this.filtros == 'Cortos' ||
              this.filtros == 'Largos' ||
              this.filtros == 'Todo'
          "
          class="mx-auto w-full my-2 flex flex-row justify-between"
        >
          <!--h2 class="mx-3 text-2xl flex w-1/2"> Buscar </h2-->
          <input
            class="
              appearance-none
              w-full
              border
              rounded
              py-3
              px-4
              leading-tight
              focus:outline-none
            "
            type="text"
            placeholder="Buscar"
            v-model="searchQuery"
          />
          <span class="material-icons text-4xl my-auto m-2">search</span>
        </div>
        <div>
          <div
            class="mx-auto w-full my-2"
            v-if="
              this.filtros == 'Salud' ||
                this.filtros == 'Cortos' ||
                this.filtros == 'Largos' ||
                this.filtros == 'Todo'
            "
          >
            <div
              class="horline w-full md:w-full px-3 mb-6 md:mb-0"
              v-if="
                this.filtros == 'Todo' ||
                  this.filtros == 'Cortos' ||
                  this.filtros == 'Largos'
              "
            >
              <!-- Color -->
              <div class="horline flex items-center justify-between relative">
                <div>
                  <h2 class="text-2xl">Color</h2>
                </div>
                <button
                  type="button"
                  @click="isOpenColor = !isOpenColor"
                  class="w-8 h-8 border border-primary rounded-full focus:outline-none focus:shadow-outline inline-flex  shadow"
                  :style="`background: ${colorSelected}; color: black`"
                >
                  <svg
                    class="w-6 h-6 my-auto mx-auto fill-current"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      d="M15.584 10.001L13.998 8.417 5.903 16.512 5.374 18.626 7.488 18.097z"
                    />
                    <path
                      d="M4.03,15.758l-1,4c-0.086,0.341,0.015,0.701,0.263,0.949C3.482,20.896,3.738,21,4,21c0.081,0,0.162-0.01,0.242-0.03l4-1 c0.176-0.044,0.337-0.135,0.465-0.263l8.292-8.292l1.294,1.292l1.414-1.414l-1.294-1.292L21,7.414 c0.378-0.378,0.586-0.88,0.586-1.414S21.378,4.964,21,4.586L19.414,3c-0.756-0.756-2.072-0.756-2.828,0l-2.589,2.589l-1.298-1.296 l-1.414,1.414l1.298,1.296l-8.29,8.29C4.165,15.421,4.074,15.582,4.03,15.758z M5.903,16.512l8.095-8.095l1.586,1.584 l-8.096,8.096l-2.114,0.529L5.903,16.512z"
                    />
                  </svg>
                </button>
                <div
                  v-show="isOpenColor"
                  @click="isOpenColor = false"
                  class="origin-top-right absolute right-0 mt-12 w-40 rounded-md shadow-lg z-50 bg-secondary"
                >
                  <div class="rounded-md bg-white shadow-xs px-4 py-3">
                    <div class="flex flex-wrap -mx-2">
                      <template>
                        <div
                          class="px-2"
                          v-for="color in colors"
                          v-bind:index="color"
                          v-bind:key="color"
                        >
                          <template v-if="colorSelected === color">
                            <div
                              class="w-8 h-8 inline-flex rounded-full cursor-pointer border-4 border-secondary"
                              :style="
                                `background: ${color}; box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.3);`
                              "
                            ></div>
                          </template>
                          <template v-if="colorSelected != color">
                            <div
                              @click="colorSelected = color"
                              @keydown.enter="colorSelected = color"
                              role="checkbox"
                              tabindex="0"
                              :aria-checked="colorSelected"
                              class="w-8 h-8 inline-flex rounded-full cursor-pointer border-4 border-white focus:outline-none focus:shadow-outline"
                              :style="`background: ${color};`"
                            ></div>
                          </template>
                        </div>
                      </template>
                      <div
                        class="mx-1  w-10 h-10 rounded-full cursor-pointer border-4 border-secondary bg-primary"
                      >
                        <button
                          type="button"
                          @click="cleanColors"
                          class="inline-flex w-full h-full"
                        >
                          <span
                            class="material-icons text-secondary text-lg my-auto mx-auto"
                            >delete</span
                          >
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Color-->
              <!-- Talla-->
              <div class="mx-auto w-full my-2">
                <div class="horline flex flex-row justify-between">
                  <h2 class="text-2xl">Talla</h2>
                </div>
                <div class="filters flex flex-row flex-wrap p-1 justify-start">
                  <input
                    type="checkbox"
                    value="XS"
                    v-model="talla"
                    id="tallaxs"
                    class="hidden"
                  />
                  <label for="tallaxs" class="flex relative">
                    <p
                      class="absolute  z-10 flex justify-center w-full h-full items-center"
                      :style="
                        `background: ${
                          isSelectedSize('XS') ? 'black' : 'transparent'
                        }; color: ${isSelectedSize('XS') ? 'white' : 'black'};`
                      "
                    >
                      <strong class="my-auto mx-auto">XS</strong>
                    </p>
                  </label>
                  <input
                    type="checkbox"
                    value="S"
                    v-model="talla"
                    id="tallas"
                    class="hidden"
                  />
                  <label for="tallas" class="flex relative">
                    <p
                      class="absolute  z-10 flex justify-center w-full h-full items-center"
                      :style="
                        `background: ${
                          isSelectedSize('S') ? 'black' : 'transparent'
                        }; color: ${isSelectedSize('S') ? 'white' : 'black'};`
                      "
                    >
                      <strong class="my-auto mx-auto">S</strong>
                    </p>
                  </label>
                  <input
                    type="checkbox"
                    value="M"
                    v-model="talla"
                    id="tallams"
                    class="hidden"
                  />
                  <label for="tallams" class="flex relative">
                    <p
                      class="absolute  z-10 flex justify-center w-full h-full items-center"
                      :style="
                        `background: ${
                          isSelectedSize('M') ? 'black' : 'transparent'
                        }; color: ${isSelectedSize('M') ? 'white' : 'black'};`
                      "
                    >
                      <strong class="my-auto mx-auto">M</strong>
                    </p>
                  </label>
                  <input
                    type="checkbox"
                    value="L"
                    v-model="talla"
                    id="tallal"
                    class="hidden"
                  />
                  <label for="tallal" class="flex relative">
                    <p
                      class="absolute  z-10 flex justify-center w-full h-full items-center"
                      :style="
                        `background: ${
                          isSelectedSize('L') ? 'black' : 'transparent'
                        }; color: ${isSelectedSize('L') ? 'white' : 'black'};`
                      "
                    >
                      <strong class="my-auto mx-auto">L</strong>
                    </p>
                  </label>
                  <!-- <input type="checkbox" value="LG" v-model="talla" id="tallalg" class="hidden">
                        <label for="tallalg" class="flex relative">
                            <p class="absolute text-primary z-10 flex justify-center w-full h-full items-center"><strong class="my-auto mx-auto">LG</strong></p>
                        </label> -->
                  <input
                    type="checkbox"
                    value="XL"
                    v-model="talla"
                    id="tallaxl"
                    class="hidden"
                  />
                  <label for="tallaxl" class="flex relative">
                    <p
                      class="absolute z-10 flex justify-center w-full h-full items-center"
                      :style="
                        `background: ${
                          isSelectedSize('XL') ? 'black' : 'transparent'
                        }; color: ${isSelectedSize('XL') ? 'white' : 'black'};`
                      "
                    >
                      <strong class="my-auto mx-auto">XL</strong>
                    </p>
                  </label>
                  <input
                    type="checkbox"
                    value="1XL"
                    v-model="talla"
                    id="talla1xl"
                    class="hidden"
                  />
                  <label for="talla1xl" class="flex relative">
                    <p
                      class="absolute z-10 flex justify-center w-full h-full items-center"
                      :style="
                        `background: ${
                          isSelectedSize('1XL') ? 'black' : 'transparent'
                        }; color: ${isSelectedSize('1XL') ? 'white' : 'black'};`
                      "
                    >
                      <strong class="my-auto mx-auto">1XL</strong>
                    </p>
                  </label>
                  <input
                    type="checkbox"
                    value="2XL"
                    v-model="talla"
                    id="talla2xl"
                    class="hidden"
                  />
                  <label for="talla2xl" class="flex relative">
                    <p
                      class="absolute z-10 flex justify-center w-full h-full items-center"
                      :style="
                        `background: ${
                          isSelectedSize('2XL') ? 'black' : 'transparent'
                        }; color: ${isSelectedSize('2XL') ? 'white' : 'black'};`
                      "
                    >
                      <strong class="my-auto mx-auto">2XL</strong>
                    </p>
                  </label>
                  <input
                    type="checkbox"
                    value="3XL"
                    v-model="talla"
                    id="talla3xl"
                    class="hidden"
                  />
                  <label for="talla3xl" class="flex relative">
                    <p
                      class="absolute z-10 flex justify-center w-full h-full items-center"
                      :style="
                        `background: ${
                          isSelectedSize('3XL') ? 'black' : 'transparent'
                        }; color: ${isSelectedSize('3XL') ? 'white' : 'black'};`
                      "
                    >
                      <strong class="my-auto mx-auto">3XL</strong>
                    </p>
                  </label>
                  <input
                    type="checkbox"
                    value="4XL"
                    v-model="talla"
                    id="talla4xl"
                    class="hidden"
                  />
                  <label for="talla4xl" class="flex relative">
                    <p
                      class="absolute z-10 flex justify-center w-full h-full items-center"
                      :style="
                        `background: ${
                          isSelectedSize('4XL') ? 'black' : 'transparent'
                        }; color: ${isSelectedSize('4XL') ? 'white' : 'black'};`
                      "
                    >
                      <strong class="my-auto mx-auto">4XL</strong>
                    </p>
                  </label>
                </div>
              </div>
              <!-- talla -->
            </div>
          </div>
        </div>
        <div
          v-if="searchQuery"
          class="hidden horline text-xs flex md:block md:flex justify-start"
        >
          <a class="flex italic">Resultados para:&nbsp;&nbsp;</a>
          <p class="flex not-italic text-xs font-black">{{ searchQuery }}</p>
        </div>
        <router-link
          class="mx-auto"
          :to="{ name: 'tienda', query: { filtros: 'Todo' } }"
        >
          <a class="mx-auto mt-4 text-2xl tracking-wide cursor-pointer"
            >Alquiler</a
          >
        </router-link>
        <menu class="p-1 mx-auto flex flex-col w-full space-y-2">
          <li class="hover:bg-primary hover:bg-opacity-25 hover:text-secondary">
            <router-link
              class=""
              @click.native="searchQuery = null"
              :to="{ name: 'tienda', query: { filtros: 'Largos' } }"
            >
              <a class="lg:ml-12">Vestidos Largos</a>
            </router-link>
          </li>
          <li class="hover:bg-primary hover:bg-opacity-25 hover:text-secondary">
            <router-link
              @click.native="searchQuery = null"
              :to="{ name: 'tienda', query: { filtros: 'Cortos' } }"
            >
              <a class="lg:ml-12">Vestidos Cortos</a>
            </router-link>
          </li>
          <li class="hover:bg-primary hover:bg-opacity-25 hover:text-secondary">
            <router-link
              @click.native="searchQuery = null"
              :to="{ name: 'tienda', query: { filtros: 'Tacones' } }"
            >
              <a class="lg:ml-12">Tacones</a>
            </router-link>
          </li>
          <li class="hover:bg-primary hover:bg-opacity-25 hover:text-secondary">
            <router-link
              @click.native="searchQuery = null"
              :to="{ name: 'tienda', query: { filtros: 'Accesorios' } }"
            >
              <a class="lg:ml-12">Accesorios</a>
            </router-link>
          </li>
          <li class="hover:bg-primary hover:bg-opacity-25 hover:text-secondary">
            <router-link
              @click.native="searchQuery = null"
              :to="{ name: 'tienda', query: { filtros: 'Todo' } }"
            >
              <a class="lg:ml-12">Ver todo</a>
            </router-link>
          </li>
        </menu>
        <router-link
          class="mx-auto"
          @click.native="searchQuery = null"
          :to="{ name: 'tienda', query: { filtros: 'Todo+Ventas' } }"
        >
          <a class="mx-auto text-2xl tracking-wide cursor-pointer">Ventas</a>
        </router-link>
        <menu class="p-1 flex flex-col w-full mx-auto mb-4 space-y-2">
          <li class="hover:bg-primary hover:bg-opacity-25 hover:text-secondary">
            <router-link
              @click.native="searchQuery = null"
              :to="{ name: 'tienda', query: { filtros: 'Largos+Ventas' } }"
            >
              <a class="lg:ml-12">Vestidos Largos</a>
            </router-link>
          </li>
          <li class="hover:bg-primary hover:bg-opacity-25 hover:text-secondary">
            <router-link
              @click.native="searchQuery = null"
              :to="{ name: 'tienda', query: { filtros: 'Cortos+Ventas' } }"
            >
              <a class="lg:ml-12">Vestidos Cortos</a>
            </router-link>
          </li>
          <li class="hover:bg-primary hover:bg-opacity-25 hover:text-secondary">
            <router-link
              @click.native="searchQuery = null"
              :to="{ name: 'tienda', query: { filtros: 'Accesorios+Ventas' } }"
            >
              <a class="lg:ml-12">Accesorios</a>
            </router-link>
          </li>
          <li class="hover:bg-primary hover:bg-opacity-25 hover:text-secondary">
            <router-link
              @click.native="searchQuery = null"
              :to="{
                name: 'tienda',
                query: { filtros: 'Complementos+Ventas' },
              }"
            >
              <a class="lg:ml-12">Complementos</a>
            </router-link>
          </li>
          <li class="hover:bg-primary hover:bg-opacity-25 hover:text-secondary">
            <router-link
              @click.native="searchQuery = null"
              :to="{ name: 'tienda', query: { filtros: 'Salud' } }"
            >
              <a class="lg:ml-12">Productos de Salud</a>
            </router-link>
          </li>
          <li class="hover:bg-primary hover:bg-opacity-25 hover:text-secondary">
            <router-link
              @click.native="searchQuery = null"
              :to="{ name: 'tienda', query: { filtros: 'Belleza' } }"
            >
              <a class="lg:ml-12">Productos de Belleza</a>
            </router-link>
          </li>
          <li class="hover:bg-primary hover:bg-opacity-25 hover:text-secondary">
            <router-link
              @click.native="searchQuery = null"
              :to="{ name: 'tienda', query: { filtros: 'Todo+Ventas' } }"
            >
              <a class="lg:ml-12">Ver todo</a>
            </router-link>
          </li>
        </menu>
      </div>
      <!-- Filtros -->
      <CardModal :showing="isOpen" v-on:close="isOpen = false">
        <div class="flex flex-col horline">
          <div
            v-if="
              this.filtros == 'Salud' ||
                this.filtros == 'Cortos' ||
                this.filtros == 'Largos'
            "
            class="horline mx-auto w-full my-2 flex flex-row justify-between"
          >
            <!--h2 class="mx-3 text-2xl flex w-1/2"> Buscar </h2-->
            <input
              class="
                appearance-none
                w-full
                border
                rounded
                py-3
                px-4
                leading-tight
                focus:outline-none
              "
              type="text"
              placeholder="Buscar"
              v-model="searchQuery"
            />
            <button
              class="focus:outline-none material-icons text-4xl my-auto m-2"
              @click="isOpen = false"
            >
              search
            </button>
          </div>
          <!--div v-if="searchQuery" class="horline text-xs flex">
                        <a class="italic">Resultados para:&nbsp;&nbsp;</a><p class="not-italic text-xs font-black">{{ searchQuery }}</p>
                    </div-->
          <router-link
            @click.native="cleanFilters()"
            class="mx-auto"
            :to="{ name: 'tienda', query: { filtros: 'Todo' } }"
          >
            <a class="mx-auto mt-4 text-xl tracking-wide cursor-pointer"
              >Alquiler</a
            >
          </router-link>
          <router-link
            @click.native="cleanFilters()"
            class=""
            :to="{ name: 'tienda', query: { filtros: 'Largos' } }"
          >
            <a class="lg:ml-12">Vestidos Largos</a>
          </router-link>
          <router-link
            @click.native="cleanFilters()"
            :to="{ name: 'tienda', query: { filtros: 'Tacones' } }"
          >
            <a class="lg:ml-12">Tacones</a>
          </router-link>
          <router-link
            @click.native="cleanFilters()"
            :to="{ name: 'tienda', query: { filtros: 'Cortos' } }"
          >
            <a class="lg:ml-12">Vestidos Cortos</a>
          </router-link>
          <router-link
            @click.native="cleanFilters()"
            :to="{ name: 'tienda', query: { filtros: 'Accesorios' } }"
          >
            <a class="lg:ml-12">Accesorios</a>
          </router-link>
          <router-link
            @click.native="cleanFilters()"
            :to="{ name: 'tienda', query: { filtros: 'Todo' } }"
          >
            <a class="lg:ml-12">Ver todo</a>
          </router-link>
          <router-link
            @click.native="cleanFilters()"
            class="mx-auto"
            :to="{ name: 'tienda', query: { filtros: 'Todo+Ventas' } }"
          >
            <a class="mx-auto text-xl tracking-wide cursor-pointer">Ventas</a>
          </router-link>
          <router-link
            @click.native="cleanFilters()"
            :to="{ name: 'tienda', query: { filtros: 'Largos+Ventas' } }"
          >
            <a class="lg:ml-12">Vestidos Largos</a>
          </router-link>
          <router-link
            @click.native="cleanFilters()"
            :to="{ name: 'tienda', query: { filtros: 'Cortos+Ventas' } }"
          >
            <a class="lg:ml-12">Vestidos Cortos</a>
          </router-link>
          <router-link
            @click.native="cleanFilters()"
            :to="{ name: 'tienda', query: { filtros: 'Accesorios+Ventas' } }"
          >
            <a class="lg:ml-12">Accesorios</a>
          </router-link>
          <router-link
            @click.native="cleanFilters()"
            :to="{ name: 'tienda', query: { filtros: 'Complementos+Ventas' } }"
          >
            <a class="lg:ml-12">Complementos</a>
          </router-link>
          <router-link
            @click.native="cleanFilters()"
            :to="{ name: 'tienda', query: { filtros: 'Salud' } }"
          >
            <a class="lg:ml-12">Productos de Salud</a>
          </router-link>
          <router-link
            @click.native="cleanFilters()"
            :to="{ name: 'tienda', query: { filtros: 'Belleza' } }"
          >
            <a class="lg:ml-12">Productos de Belleza</a>
          </router-link>
          <router-link
            @click.native="cleanFilters()"
            :to="{ name: 'tienda', query: { filtros: 'Todo+Ventas' } }"
          >
            <a class="lg:ml-12">Ver todo</a>
          </router-link>
        </div>
      </CardModal>
      <CardModal :showing="isShare" v-on:close="isShare = false">
        <h1
          class="mx-auto mt-4 text-xl font-bold md:text-3xl tracking-wide cursor-pointer"
        >
          Compartir este Producto
        </h1>
        <div class="flex flex-row w-full h-full mt-8 justify-around">
          <div @click="copyURL(itemShared)" class="bg-primary rounded-full p-1">
            <span class="material-icons text-secondary text-2xl p-1"
              >filter_none</span
            >
          </div>
          <!-- "'/'+itemShared.producto+'/'+itemShared.id+'/'" -->
          <a
            :href="
              'https://twitter.com/intent/tweet?text=' +
                'https://ciosve.com' +
                '/' +
                itemShared.producto +
                '/' +
                itemShared.id +
                '/'
            "
          >
            <img src="@/assets/media/tw-black.svg" width="40" height="40" />
          </a>
          <a
            :href="
              'https://wa.me/?text=' +
                'https://ciosve.com/' +
                '/' +
                itemShared.producto +
                '/' +
                itemShared.id +
                '/'
            "
          >
            <img src="@/assets/media/ws-black.svg" width="40" height="40" />
          </a>
          <a
            :href="
              'https://facebook.com/sharer.php?u=' +
                'https://ciosve.com/' +
                '/' +
                itemShared.producto +
                '/' +
                itemShared.id +
                '/'
            "
          >
            <img src="@/assets/media/fb-black.svg" width="40" height="40" />
          </a>
          <div v-if="false">
            <img src="@/assets/media/gm-black.svg" width="40" height="40" />
          </div>
        </div>
      </CardModal>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

//import Placeholder from '@/components/shared/placeholder.vue'
import LazyImage from "./LazyImage.vue";
import CardModal from "@/components/shared/CardModal.vue";
import firebase_anal from "firebase";
export default {
  props: ["filtros"],
  components: {
    CardModal,
    LazyImage,
    //'place-img': Placeholder
  },
  data() {
    return {
      cantidad: 9,
      longitud: "",
      filterModal: false,
      searchModal: false,
      searchQuery: null,
      isOpen: false,
      isOpenColor: false,
      isOpenMaterial: false,
      isOpenColeccion: false,
      isOpenTalla: false,
      isShare: false,
      itemShared: {},
      cards: null,
      tallaOptions: ["XS", "S", "M", "L", "XL", "1XL", "2XL", "3XL", "4XL"],
      talla: ["XS", "S", "M", "L", "XL", "1XL", "2XL", "3XL", "4XL"],
      desc: "Un vestido de prueba.",
      colors: [
        "#FFF",
        "#1a1a1a",
        "#c4c2c4",
        "#ffdd00",
        "#2196F3",
        "#cf0000",
        "#f5742a",
        "#a600ff",
        "#f78fe4",
        "#661923",
        "#fff8e7",
        "#2e8b57",
        "#8d6740",
      ],
      colorSelected: [
        "#000",
        "#1a1a1a",
        "#c4c2c4",
        "#ffdd00",
        "#2196F3",
        "#cf0000",
        "#f5742a",
        "#a600ff",
        "#f78fe4",
        "#661923",
        "#fff8e7",
        "#2e8b57",
        "#8d6740",
        "#FFF",
      ],
      //filtros: this.filtros,
    };
  },
  methods: {
    ...mapActions([
      "loadVestidos",
      "loadMoreDress",
      "loadComplementos",
      "loadAccesorios",
      "loadSalud",
      "loadBelleza",
      "loadZapatos",
    ]),
    toggleAccordion: function() {
      this.isOpen = !this.isOpen;
    },
    toggleColor: function() {
      this.isOpenColor = !this.isOpenColor;
    },
    toggleMaterial: function() {
      this.isOpenMaterial = !this.isOpenMaterial;
    },
    toggleTalla: function() {
      this.isOpenTalla = !this.isOpenTalla;
    },
    toggleColeccion: function() {
      this.isOpenColeccion = !this.isOpenColeccion;
    },
    toggleShare: function() {
      this.isShare = !this.isShare;
    },

    cleanFilters() {
      this.searchQuery = null;
      this.isOpen = false;
    },
    onPickFile() {
      this.$refs.fileInput.click();
    },
    cleanColors() {
      this.colorSelected = [
        "#2d3748",
        "#FAFAFA",
        "#1a1a1a",
        "#afbbc9",
        "#ffdd00",
        "#2196F3",
        "#cf0000",
        "#f5742a",
        "#a600ff",
        "#f78fe4",
        "#",
      ];
    },
    loadMore() {
      if (
        this.filtros != "Salud+Belleza" &&
        this.filtros != "Accesorios" &&
        this.filtros != "Complementos+Ventas" &&
        this.filtros != "Accesorios+Ventas"
      ) {
        this.cantidad = this.cantidad + 9;
        this.loadMoreDress();
      }
    },
    shareDress(item) {
      this.itemShared = item;
      this.isShare = !this.isShare;
    },
    contacto() {
      firebase_anal
        .analytics()
        .logEvent("contacto_vestido", { name: "contacto_vestido" });
    },
    isSelectedSize: function(size) {
      return this.talla.includes(size);
    },
    consulta() {
      firebase_anal
        .analytics()
        .logEvent("consulta_vestido", { name: "consulta_vestido" });
    },
    async copyURL(item) {
      try {
        await navigator.clipboard.writeText(
          "https://ciosve.com/" + item.producto + "/" + item.id + "/"
        );
        this.isShare = false;
      } catch ($e) {
        alert("Cannot copy error");
      }
    },
  },
  beforeMount() {
    this.loadVestidos();
    this.loadAccesorios();
    this.loadComplementos();
    this.loadSalud();
    this.loadBelleza();
    this.loadZapatos();
  },
  mounted() {
    //this.scroll();
  },
  computed: {
    ...mapGetters([
      "getVestidos",
      "getLoading",
      "getAccesorios",
      "getComplementos",
      "getSalud",
      "getBelleza",
      "getZapatos",
    ]),
    vestidos() {
      if (this.searchQuery) {
        if (this.filtros == "Salud")
          return this.getSalud.filter((item) => {
            return (
              this.searchQuery
                //.toLowerCase()
                .split(" ")
                .every((v) => item.name.toLowerCase().includes(v))
            );
          });
        else if (this.filtros == "Cortos" || this.filtros == "Largos") {
          return this.getVestidos.filter((item) => {
            if (!item.name) return false;
            const lowerCaseName = item.name.toLowerCase();
            return this.searchQuery
              .toLowerCase()
              .split(" ")
              .every((v) => lowerCaseName.includes(v));
          });
        } else {
          return this.getVestidos;
        }
      } else {
        if (
          this.getVestidos != null &&
          this.getAccesorios != null &&
          this.getComplementos != null &&
          this.getSalud != null &&
          this.getBelleza != null
        ) {
          const filterMap = {
            Accesorios: () => this.getAccesorios,
            Todo: () =>
              this.getAccesorios
                .concat(this.getVestidos)
                .concat(this.getComplementos)
                .filter(
                  (x) =>
                    this.colorSelected.includes(x.color) &&
                    this.talla.some((y) => x.talla.includes(y))
                ),
            "Complementos+Ventas": () => this.getComplementos,
            Tacones: () => this.getZapatos,
            Cortos: () =>
              this.getVestidos
                .filter((x) => x.estilo == "Corto")
                .filter(
                  (x) =>
                    this.colorSelected.includes(x.color) &&
                    this.talla.some((y) => x.talla.includes(y))
                ),
            Largos: () =>
              this.getVestidos
                .filter((x) => x.estilo == "Largo")
                .filter(
                  (x) =>
                    this.colorSelected.includes(x.color) &&
                    this.talla.some((y) => x.talla.includes(y))
                ),
            "Largos+Ventas": () =>
              this.getVestidos.filter(
                (x) => x.estilo == "Largo" && x.tipo != "Alquiler"
              ),
            "Cortos+Ventas": () =>
              this.getVestidos.filter(
                (x) => x.estilo == "Corto" && x.tipo != "Alquiler"
              ),
            "Accesorios+Ventas": () =>
              this.getAccesorios.filter((x) => x.tipo != "Alquiler"),
            Salud: () => this.getSalud,
            Belleza: () => this.getBelleza,
            "Todo+Ventas": () =>
              this.getVestidos
                .filter((x) => x.tipo != "Alquiler")
                .concat(this.getComplementos)
                .concat(this.getSalud)
                .concat(this.getBelleza)
                .concat(this.getAccesorios.filter((x) => x.tipo != "Alquiler")),
          };
          const results = filterMap[this.filtros]();
          return results;
        } else {
          return this.getVestidos;
        }
      }
    },
    titulo() {
      if (this.filtros == "Accesorios") {
        return "Accesorios";
      } else if (this.filtros == "Todo") {
        return "Todos nuestros Productos";
      } else if (this.filtros == "Complementos+Ventas") {
        return "Complementos";
      } else if (this.filtros == "Cortos") {
        return "Vestidos Cortos";
      } else if (this.filtros == "Largos") {
        return "Vestidos Largos";
      } else if (this.filtros == "Largos+Ventas") {
        return "Vestidos Largos en Venta";
      } else if (this.filtros == "Cortos+Ventas") {
        return "Vestidos Cortos en Venta";
      } else if (this.filtros == "Accesorios+Ventas") {
        return "Accesorios en Venta";
      } else if (this.filtros == "Salud") {
        return "Productos de Salud";
      } else if (this.filtros == "Belleza") {
        return "Productos de Belleza";
      } else if (this.filtros == "Todo+Ventas") {
        return "Productos en Venta";
      } else {
        return "Alquiler y Venta de Vestidos";
      }
    },
    /*vestidos() {
            return this.getVestidos.filter(
                    this.talla.includes(x.talla) &&
                    this.colorSelected.includes(x.color
                    )
                },*/
    accordionColor: function() {
      return {
        "is-closed": !this.isOpenColor,
      };
    },
    accordionTalla: function() {
      return {
        "is-closed": !this.isOpenTalla,
      };
    },
    accordionMaterial: function() {
      return {
        "is-closed": !this.isOpenMaterial,
      };
    },
    accordionColeccion: function() {
      return {
        "is-closed": !this.isOpenColeccion,
      };
    },
    enlace() {
      return "https://ciosve.com";
    },
    pidelo() {
      return (
        "https://wa.me/584128002579?text=" +
        "Me%20encuentro%20interesado%20en%20el%20producto:%20" +
        "https://ciosve.com"
      );
    },
    cargando() {
      return this.getLoading;
    },
  },
};
</script>
<style scoped>
/*input {
    display: none;
}*/

/*.textbar{
    display: block;
}*/
label {
  cursor: pointer;
  margin: 5px 5px;
}

label:before {
  content: "";
  display: inline-block;
  height: 33px;
  width: 50px;
  border: 2px solid rgb(0, 0, 0, 0.8);
  /*border-radius: 45%;*/
  z-index: 2;
  /*transition: box-shadow 0.4s ease, background 0.3s ease;*/
}

input:checked + label:before {
  color: white !important;
  background: #87ceeb;
  /*background: radial-gradient(
    square,
    rgba(142, 142, 142, 0.2) 40%,
    rgba(0, 0, 0, 0.5) 100%
  );*/
}

.arriba {
  z-index: 999;
}

menu {
  list-style: none;
}

li {
  font-family: "Montserrat", serif;
}

p {
  font-family: "Montserrat", serif;
}

h3,
h2 {
  font-family: "Playfair display", serif;
  font-style: italic;
}

.card {
  padding-bottom: 56.25%;
}

.head {
  background: linear-gradient(
    to top,
    rgba(0, 0, 0, 1) 0%,
    rgba(0, 0, 0, 1) 100%
  );
}

.conte {
  /*min-height: 150px;*/
  height: 350px;
  width: 100%;
  object-fit: cover no-repeat;
}

.filters {
  max-height: 10rem;
  overflow: hidden;
  transition: 0.5s ease all;
}

.is-closed .filters {
  max-height: 0px;
}

.parent {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 0.1fr) 3fr;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  grid-template-areas:
    "main main"
    "main main"
    "one one";
}

.div1 {
  grid-area: main;
}

.div2 {
  grid-area: one;
  overflow-y: scroll;
  background: transparent;
}

::-webkit-scrollbar {
  width: 0px;
  background: transparent;
}

.div3 {
  grid-area: two;
  overflow-y: scroll;
  background: linear-gradient(
    30deg,
    rgba(131, 133, 142, 0.4) 0%,
    rgba(237, 237, 237, 0.5) 45%
  );
}

.div4 {
  grid-area: tree;
  overflow-y: scroll;
  background: linear-gradient(
    30deg,
    rgba(131, 133, 142, 0.1) 0%,
    rgba(237, 237, 237, 0.5) 45%
  );
}

.horline {
  border-bottom: 3px solid theme("colors.primary");
  padding-bottom: 5%;
}

@media only screen and (min-width: 760px) {
  .parent {
    display: grid;
    grid-template-columns: 0.5fr repeat(2, 1fr);
    grid-template-rows: 0.2fr repeat(4, 0.8fr);
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .div1 {
    grid-area: 1 / 1 / 2 / 4;
    border: none;
  }

  .div2 {
    grid-area: 2 / 2 / 6 / 4;
    overflow-y: scroll;
    box-sizing: content-box;
    background: linear-gradient(
      120deg,
      rgba(131, 133, 142, 0) 0%,
      rgba(237, 237, 237, 0) 65%
    );
  }

  ::-webkit-scrollbar {
    width: 0px;
    background: transparent;
  }

  .div3 {
    grid-area: 2 / 1 / 6 / 2;
    background: transparent;
  }
}
</style>
